import { render } from "./Colony.vue?vue&type=template&id=5fe877b0&ts=true"
import script from "./Colony.vue?vue&type=script&lang=ts"
export * from "./Colony.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__